import React, { useEffect, useState } from "react";
import DismissableAlert from "./DismissableAlert";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import jwt_decode from "jwt-decode";

const Notifications = (props) => {

    const [alerts, setAlrets] = useState([]);

    useEffect(() => {

        if ( ! props.jwt ) return;

        const jwtDecoded = jwt_decode(props.jwt);

        const savedUserNotifications = getWithExpiry( `user_notifications_${jwtDecoded?.id}` );

        if ( savedUserNotifications ) {
            setAlrets( savedUserNotifications );
        } else {

            (async () => {

                let userRequestData = new FormData();
                userRequestData.append( 'token', props.jwt );

                try {
                    const response = await fetch(
                        `${configVars.apiUrl}sustainchange/v1/getusernotifications/`,
                        {
                            method: "POST",
                            headers: {
                                Authorization: `Basic ${configVars.auth}`,
                            },
                            body: userRequestData
                        }
                    );
            
                    const userResponse = await response.json();
                    
                    if ( userResponse ) {

                        if ( userResponse.data && userResponse.data.length > 0 ) {
                            setAlrets( userResponse.data );
                            setWithExpiry( `user_notifications_${jwtDecoded?.id}`, userResponse.data );
                        }

                        //console.log( userResponse );
                    }

                } catch (error) {
                    console.log({ error });
                }

            })();

        }

    }, [props.jwt]);

    return(
        <div className="notifications-wrap pt-4">

            { alerts && alerts.length > 0 && (
                <>
                    {alerts.map( ( alert, i ) => {
                        return(
                            <DismissableAlert data={alert} key={i} />
                        )
                    })}
                </>
            )}

        </div>
    )

}

export default Notifications;